

<div class="block-table">
	<h2 translate class="noprint" i18n="ueberblick@@ueberblick">Fensterwerte im Überblick</h2>
	<div class="info-calc">
		<p i18n="Infos|Infos zu Einheiten@@EinheitenInfos">Zur Info:<br>Höhen, Breiten und Glas sind in <span>mm</span> angegeben, Ug- und UW-Werte in
			<span>W/m²K</span>, Randverbund in <span>W/mK</span>, Windlast in
			<span>N/m²</span>, A aero und A geom in <span>m²</span></p>
	</div>
	<mat-table [dataSource]="dataSource" class="mat-elevation-z8">

		<ng-container matColumnDef="system">
			<mat-header-cell *matHeaderCellDef i18n="System@@System">System</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="System@@System" class="mobile-label">System</span> {{element.system}}</mat-cell >
		</ng-container>

		<ng-container matColumnDef="windowQuantity">
			<mat-header-cell *matHeaderCellDef i18n="Fensterzahl Tabelle@@FensterzahlTabelle">Fenster</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Fensterzahl Tabelle@@FensterzahlTabelle" class="mobile-label">Fenster</span> {{element.windowQuantity}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="middleMullion">
			<mat-header-cell mat-header-cell *matHeaderCellDef i18n="Mittelpfosten Tabelle@@MittelpfostenTabelle">MP</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Mittelpfosten Tabelle@@MittelpfostenTabelle" class="mobile-label">MP</span> {{element.middleMullion}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="dimension">
			<mat-header-cell mat-header-cell *matHeaderCellDef i18n="Dimensionen Tabelle@@DimensionenTabelle">B/H</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Dimensionen Tabelle@@DimensionenTabelle" class="mobile-label">B/H</span> {{element.dimension}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="louvre">
			<mat-header-cell *matHeaderCellDef i18n="Lamellenhöhe Tabelle@@LamellenhöheTabelle">Lam. -höhe</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Lamellenhöhe Tabelle@@LamellenhöheTabelle" class="mobile-label">Lam. -höhe</span> {{element.louvre}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="glassThickness">
			<mat-header-cell *matHeaderCellDef i18n="Glas Tabelle@@GlasTabelle">Glas</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Glas Tabelle@@GlasTabelle" class="mobile-label">Glas</span>{{element.glassType}}  /  {{element.glassThickness |  number : '1.0-2'}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="ug">
			<mat-header-cell *matHeaderCellDef i18n="Ug Tabelle@@UgTabelle">Ug</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Ug Tabelle@@UgTabelle" class="mobile-label">Ug</span> {{element.ug |  number : '1.0-2'}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="psi">
			<mat-header-cell *matHeaderCellDef >Ψ</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span translate class="mobile-label">Ψ</span> {{element.psi |  number : '1.0-3'}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="aGeoTotal">
			<mat-header-cell *matHeaderCellDef i18n="Ageo Gesamt Tabelle@@AgeoGesamtTabelle">A geom(Ges)</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Ageo Gesamt Tabelle@@AgeoGesamtTabelle" class="mobile-label">A geom(Ges)</span> {{element.aGeoTotal |  number : '1.0-2'}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="aAeroTotal">
			<mat-header-cell *matHeaderCellDef i18n="Aaero Gesamt Tabelle@@AaeroGesamtTabelle">A aero(Ges)</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Aaero Gesamt Tabelle@@AaeroGesamtTabelle" class="mobile-label">A aero(Ges)</span> {{element.aAeroTotal |  number : '1.0-2'}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="isolation">
			<mat-header-cell *matHeaderCellDef i18n="Dämmung Tabelle@@DämmungTabelle">Dämm.</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Dämmung Tabelle@@DämmungTabelle" class="mobile-label">Dämm.</span> {{element.isolation}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="uw">
			<mat-header-cell *matHeaderCellDef i18n="Uw Tabelle@@UwTabelle">UW</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Uw Tabelle@@UwTabelle" class="mobile-label">UW</span> {{element.uw |  number : '1.0-2'}}</mat-cell >
		</ng-container>

		<ng-container matColumnDef="windLoad">
			<mat-header-cell mat-header-cell *matHeaderCellDef i18n="Windlast Tabelle@@WindlastTabelle">Windlast</mat-header-cell>
			<mat-cell *matCellDef="let element" ><span i18n="Windlast Tabelle@@WindlastTabelle" class="mobile-label">Windlast</span> {{element.windLoad}}</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;" (click)="removeFromTable(row.id)"></mat-row>
	</mat-table>
	<button mat-raised-button color="primary" class="print-btn"  i18n="Button|Tabelle drucken@@TabelleDrucken" (click)="printTable()">Tabelle drucken</button>
	<button mat-raised-button color="primary" i18n="Button|PDF erstellen@@PdfErstellen" (click)="generatePdf('download')">PDF erstellen</button>
</div>
